import React from 'react';
import EntrylevelContent from '../function-components/EntrylevelContent'

function Entrylevel() {
    return (
      <>
          <EntrylevelContent />
      </>
    )
  }

export default Entrylevel;